// import namor from 'namor'

// import namor from "namor";
const range = len => {
  const arr = []
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
}

const dataComponents = () => {
  const statusChance = Math.random()
  
  return {
    // firstName: namor.generate({ words: 1, numbers: 0 }),
    // lastName: namor.generate({ words: 1, numbers: 0 }),
    numeros: Math.floor(Math.random() * 30),
    numeros1: Math.floor(Math.random() * 30),
    numeros2: Math.floor(Math.random() * 30),
    numeros3: Math.floor(Math.random() * 30),
    numeros4: Math.floor(Math.random() * 30),
    // status:
    //   statusChance > 0.66
    //     ? 'relationship'
    //     : statusChance > 0.33
    //     ? 'complicated'
    //     : 'single',
    // Biblioteca
    titulo: 'titulo',
    categoria: 'categoria',
    etiquetas: 'etiquetas',
    descripcion: 'descripcion',
    // EMPRESAS
    //// Empresas
    logoEmp: 'logoEmp',
    empresaEmp: 'empresaEmp',
    cifEmp: 'cifEmp',
    //// Despachos
    logoDes: 'logoEmp',
    despachoDes: 'empresaEmp',
    cifDes: 'despachosEmp',
    //// Usuarios
    empresaUsu: 'empresaUsu',
    despachoUsu: 'despachoUsu',
    nombreYapellidosUsu: 'nombreYapellidosUsu',
    telefonoUsu: 'telefonoUsu',
    emailUsu: 'emailUsu',
    estadoUsu: 'estadoUsu',
    tipoUsu: 'tipoUsu',
    ultimaConexUsu: 'ultimaConexUsu',
    //// Asociaciones
    asociacionAsoc: 'asociacionAsoc',
    grupoAsoc: 'grupoAsoc',
    acuerdoAsoc: 'acuerdoAsoc',
    provinciaAsoc: 'provinciaAsoc',
    telefonoAsoc: 'telefonoAsoc',
    emailAsoc: 'emailAsoc', 
    //// Grupos
    grupoGru: 'grupoGru',
    //// Zonas
    zonaZo: 'zonaZo',
    //// Plantilla Email Notificaciones
    logoPlan: 'logoPlan',
    plantillaEmNot: 'Plantilla Email Notificaciones',
    // Contactos
    abogadoCon: 'Asignado a',
    fechaEntradaCon: 'Fecha de Entrada',
    tipoCon: 'tipo',
    estadoCon: 'estado',
    actualizadoCon: 'actualizado',
    empresaCon: 'empresa',
    asociacionCon: 'asociacion',
    zonaCon: 'zona',
    provinciaCon: 'provincia',
    nombreYapellidosCon: 'nombreYapellidos',
    telefonoCon: 'telefono',
    emailCon: 'email',
    // Clientes
    abogadoCli: 'abogadoCli',
    empresaCli: 'empresaCli',
    asociacionCli: 'asociacionCli',
    zonaCli: 'zonaCli',
    provinciaCli: 'provinciaCli',
    nombreYapellidosCli: 'nombreYapellidosCli',
    telefonoCli: 'telefonoCli',
    emailCli: 'emailCli',
    estadoCli: 'estado',
    ultimaConexCli: 'ultimaCon',
    // VideoConferencia 
    fechaInicioVid: 'fechaInicio',
    fechaFinVid: 'fechaFin',
    nombreYapellidosVid: 'nombreYapellidosVid',
    telefonoVid: 'telefonoVid',
    emailVid: 'emailVid',
    enlaceVideoVid: 'enlaceVideocon',
    entadoCliVid: 'entadoCli',
    apellidosConVid: 'apellidosCon',
    // Expedientes 
    S: 'S', 
    T: 'T', 
    expedienteExp: 'expediente',
    fechaEntradaExp: 'fechaEntradaExp',
    fechaUltimaActExp: 'fechaUltimaAct',
    tipoExp: 'tipoExp',
    asociacionExp: 'asociacionExp',
    abogadoExp: 'abogadoExp',
    peritajeExp: 'peritaje',
    clienteExp: 'cliente',
    provinciaExp: 'provincia',
    estadoExp: 'estado',
    vencimientoExp: 'vencimiento',
    empresaExp: 'empresaExp',
    // Notificaciones
    emailOrigenNoti: 'emailOrigen',
    emailDestinoNoti: 'emailDestino',
    fechaEnvioNoti: 'fechaEnvio',
    asuntoNoti: 'asunto',
    mensajeNoti: 'mensaje', 
    /// INFORMES
    ///////   Informe General
    //  Contactos
    fechaInfGen: 'fechaInfGen',
    pteLlamadaInfGen: 'pteLlamadaInfGen',
    llamadoInfGen: 'llamadoInfGen',
    clienteInfGen: 'clienteInfGen',
    canceladoInfGen: 'canceladoInfGen',
    totalContactosInfGen: 'totalContactosInfGen',  
    //  Clientes por mes y asociación
    añoInfGen: 'añoInfGen',
    mesInfGen: 'mesInfGen',
    asociacionInfGen: 'asociacionInfGen',
    clientesInfGen: 'clientesInfGen',  
    //  Expedientes por Asociación y Zona
    asociacionInfGenAZ: 'asociacionInfGen',
    zonaInfGen: 'zonaInfGen',
    provinciaInfGen: 'provinciaInfGen',
    cantidadInfGen: 'cantidadInfGen',
    ///////
    /// CONFIGURACION
    // Empresas
    logoConfg: 'logoConfg',
    empresaConfg: 'empresaConfg',
    cifConfg: 'cifConfg',
    // Despachos
    logoConfg: 'logoConfg',
    despachoConfg: 'empresaConfg',
    cifConfg: 'despachosConfg',
    // Tipo de Usuario
    tipoDeUsuarioConfg: 'tipoDeUsuarioConfg',
    nivelConfg: 'nivelConfg',
    // Usuarios
    empresaConfg: 'empresaConfg',
    despachoConfg: 'despachoConfg',
    nombreYapellidosConfg: 'nombreYapellidosConfg',
    telefonoConfg: 'telefonoConfg',
    emailConfg: 'emailConfg',
    estadoConfg: 'estadoConfg',
    tipoConfg: 'tipoConfg',
    ultimaConexConfg: 'ultimaConexConfg',
    // Hojas de Encargo
    logoHoja: 'logoHoja',
    hojaDeEncargoCon: 'hojaDeEncargoCon',
    // Registro de Hojas de Encargo
    grupoRegistroHojasConfg: 'grupoRegistroHojasConfg',
    // Tipos de Casos
    empresaTipCas: 'empresaTipCas',
    tipoTipCas: 'tipoTipCas',
    ///////
    // Informe Llamadas 
    díaPorDia: 'díaPorDia',
    fechaPorDia: 'fechaPorDia',
    recibidasPorDia: 'recibidasPorDia',
    atendidasPorDia: 'atendidasPorDia',
    noAtendidasPorDia: 'noAtendidasPorDia',
    SinRespuestaPorDia: 'SinRespuestaPorDia',
    CanceladasPorDia: 'CanceladasPorDia',
    OtrosPorDia: 'OtrosPorDia',
    destinoPorDestino: 'destinoPorDestino',
    recibidasPorDestino: 'recibidasPorDestino',
    atendidasPorDestino: 'atendidasPorDestino',
    noAtendidasPorDestino: 'noAtendidasPorDestino',
    sinRespuestaPorDestino: 'sinRespuestaPorDestino',
    canceladasPorDestino: 'canceladasPorDestino',
    otrosPorDestino: 'otrosPorDestino',
    DiaLLa: 'DiaLLa',
    FechaLLa: 'FechaLLa',
    OrigenLLa: 'OrigenLLa',
    DestinoLLa: 'DestinoLLa',
    EstadoLLa: 'EstadoLLa',
    Duración_LlamadaLLa: 'Duración_LlamadaLLa',
    Duración_IVRLLa: 'Duración_IVRLLa',
    Duración_ConvLLa: 'Duración_ConvLLa',
    Nodo_TransfLLa: 'Nodo_TransfLLa',
    GrabaciónLLa: 'GrabaciónLLa',


  }
}

export default function makeData(...lens) {
  const makeDataLevel = (depth = 0) => {
    const len = lens[depth]
    return range(len).map(d => {
      return {
        ...dataComponents(),
        subRows: lens[depth + 1] ? makeDataLevel(depth + 1) : undefined,
      }
    })
  }

  return makeDataLevel()
}
